import theme from './theme';
import styled from 'styled-components';

export const AppWrapper = styled.div`
    outline: none;
    height: 100vh;
    .not-implemented {
        background-color: lightyellow;
        font-style: italic;
    }
    .not-implemented:after {
        content: ' (not implemented yet)';
    }

    .unblock-tank:after {
        content: ' (unblock tank...)';
    }

    .delete-cargo-operations:after {
        content: ' (delete cargo operations...)';
    }

    .delete-berths:after {
        content: ' (delete berths...)';
    }
`;

export const PageWrapper = styled.div`
    outline: none;
    display: grid;
    height: calc(100% - ${theme.constants.pageHeaderHeight} - ${theme.constants.pageHeaderMargin});
    width: 100%;
    grid-template-columns: 60px calc(100% - 60px);
    grid-template-rows: 0 auto;
    grid-template-areas:
        'header-panel header-panel'
        'left-panel content-panel';

    @media print {
        @page {
            size: landscape;
        }
        display: block;
        width: 100%;
        height: 100%;
        page-break-after: always;
        overflow: visible;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
    }
`;

export const SidePanelLeftWrapper = styled.aside`
    grid-area: left-panel;
    height: calc(100% - 5px);
    margin-left: 5px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    box-shadow: #ccc 0 2px 6px 2px;
    @media print {
        display: none;
    }
`;

export const ContentWrapper = styled.div`
    height: 100%;
    overflow: hidden;
    position: relative;
    grid-area: content-panel;
    @media print {
        display: block;
        width: 100%;
    }
`;

export const Curtain = styled.div`
     {
        position: absolute;
        left: 0;
        top: 0;
        background: #fff;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        z-index: 1;
    }
`;

export const Separator = styled.div`
        @media only screen and (max-width: 1366px) {
            display:none;
        }
        margin: 0 0.5rem;
        border-left: 1px solid #ddd;
        width: 1px;
        overflow: hidden;
        height: 100%;
        display: flex;
        align-self: center;
    }   
`;
